module.exports = __webpack_public_path__ + "static/img/banner-cursos-1680x1050.bfd2c21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-cursos-1680x1050.jpg
// module id = Rwkq
// module chunks = 47